export default "__VITE_ASSET__045543ba__"